import {Component, OnInit} from '@angular/core';
import {IndicatorBoxModel} from '../../../../models/indicator-box.model';
import {IndicatorsSearchToolbarModel} from '../../../../models/indicators-search-toolbar-model.model';
import {IndicatorsChartService, IndicatorsService} from '../../../../services/indicators/indicators.service';
import {SearchToolbarModelFactoryService} from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import {
  SearchToolbarDateFunction,
  SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection
} from '../../../../models/search-toolbar-factory-parameters.model';
import {AnalyticsService} from '../../../../services/analytics/analytics.service';
import {QFilterModel} from '../../../../models/qfilter.model';
import {TranslateService} from '@ngx-translate/core';
import {DataTableField} from '../../../../modules/UIKit/components/dataTable/dataTableField.interface';
import {StoreCampaignService} from '../../../../services/store/stores-campaign.service';
import {StoreEntry} from '../../../../models/store.model';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-elenco-pdv',
  templateUrl: './elenco-pdv.component.html',
  styleUrls: ['./elenco-pdv.component.css']
})
export class ElencoPdvComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  enableResults = false;
  storesListTitles: DataTableField[];
  translations: any;
  tableHeaders: any;

  public date_from: Date;
  public date_to: Date;
  public selectedStore: any;

  store_list: StoreEntry[];

  public data: QFilterModel;

  constructor (
    private indicatorService: IndicatorsService,
    public srvStoreCampaign: StoreCampaignService,
    private searchModelFactory: SearchToolbarModelFactoryService,
    private svcAnalytics: AnalyticsService,
    private chartsService: IndicatorsChartService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.tableHeaders = [];
  }

  searchValue(data: QFilterModel) {
    this.data = data;
    this.translate.get([
      'indicator.punti_vendita',
      'indicator.nuove_aperture',
      'indicator.fatturato',
      'indicator.numero_negozi',
      'indicator.fatturato_mq'
    ]).subscribe(t => {
      this.indicators = [];

      Observable.zip(
        this.indicatorService.indicatorCalculation('stores.Q071', this.data),
        this.indicatorService.indicatorCalculation('stores.Q072', this.data)
      ).subscribe(
        (r) => {

          const indicators = [];

          r.forEach(function(rc) { rc.forEach(function(i) { indicators.push(i); }) });

          this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'numero_negozi'), {decimal_value: 0, decimal_prec_value: 0}, t));
          this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'nuove_aperture'), {decimal_value: 0, decimal_prec_value: 0}, t));
          this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'fatturato'), {dynamic: true, unit_period_prec: '€'}, t));
          this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'fatturato_mq'), {decimal_value: 0, decimal_prec_value: 0, unit_period_prec: '€'}, t));
        });
    });


    this.translate.get([
      'stores.code',
      'stores.description',
      'stores.surface',
      'stores.address',
      'stores.city',
      'stores.label',
      'stores.customers',
      'stores.revenue',
      'stores.totalSales',
      'customerDetail.province'
    ]).subscribe(t => {
      this.tableHeaders = t;
      this.srvStoreCampaign.getListPDV(data).subscribe();
    });
    this.show_results = true

  }

  resetData() {
    this.show_results = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/elenco-pdv/elenco-pdv.component.ts